import {
  UPDATE_MESSAGE_VALUES,
  RESET_NEW_MESSAGE
} from './types';

export const updateMessage = (values) => ({
  type: UPDATE_MESSAGE_VALUES,
  payload: values
});

export const resetNewMessage = () => ({
  type: RESET_NEW_MESSAGE
});
